export default {
    checkLastLine: {
        lastLine: 0,
        lineListener(val) {},
        set line(val) {
            this.lastLine = val;
            this.lineListener(val);
        },
        get line() {
            return this.lastLine;
        },
        registerListener(listener) {
            this.lineListener = listener;
        }
    },
    setLastLine(line) {
        this.checkLastLine.line = line;
    },

    isArray(item) {
        return Object.prototype.toString.call(item) === "[object Array]";
    },
    isObject(item) {
        return Object.prototype.toString.call(item) === "[object Object]";
    },
    isNull(item) {
        return Object.prototype.toString.call(item) === "[object Null]";
    },
    isNumber(item) {
        return typeof item === "number";
    },
    isString(item) {
        return typeof item === "string";
    },
    isBoolean(item) {
        return typeof item === "boolean";
    },
    isUndefined(item) {
        return typeof item === "undefined";
    },
    getType(item) {
        let t = Object.prototype.toString.call(item);
        const match = /(?!\[).+(?=\])/g;
        t = t.match(match)[0].split(" ")[1];
        return t;
    },
    mergeArr(arr1, arr2, showAllDiff, added, deleted, differencesCounter) {
        let longer = [];
        const merged = [];
        if (arr1.length > arr2.length) {
            longer = arr1;
        } else {
            longer = arr2;
        }
        longer.forEach((item, index) => {
            if (arr1.hasOwnProperty(index) && arr2.hasOwnProperty(index)) {
                if (this.getType(arr2[index]) === this.getType(arr1[index])) {
                    if (this.isArray(arr2[index])) {
                        merged.push(this.mergeArr(arr1[index], arr2[index], showAllDiff, added, deleted, differencesCounter));
                    } else if (this.isObject(arr2[index])) {
                        merged.push(this.mergeObj(arr1[index], arr2[index], showAllDiff, added, deleted, differencesCounter));
                    } else {
                        if (arr2.includes(arr1[index]) && !merged.includes(arr1[index])) {
                            merged.push(arr1[index]);
                        }
                        if ((arr1[index] === arr2[index] || arr1.includes(arr2[index])) && !merged.includes(arr2[index])) {
                            merged.push(arr2[index]);
                        }

                        if (!arr1.includes(arr2[index])) {
                            merged.push(arr2[index]);
                            differencesCounter.added += 1;
                        }
                        if (!arr2.includes(arr1[index])) {
                            if (arr1.length >= arr2.length) {
                                merged.push(arr1[index]);
                            } else {
                                merged.unshift(arr1[index]);
                            }
                            differencesCounter.deleted += 1;
                        }
                    }
                } else {
                    differencesCounter.updated += 1;
                    merged.push(arr2[index]);
                }
            } else {
                let checkDelete = true;
                checkDelete = this.registerAllItems(merged, (showAllDiff || added), null, arr2, index, false, showAllDiff, added, deleted, differencesCounter, "added");
                if (checkDelete) {
                    checkDelete = this.registerAllItems(merged, (showAllDiff || deleted), arr1, null, index, false, showAllDiff, added, deleted, differencesCounter, "deleted");
                }
            }
        });
        return merged;
    },
    mergeObj(obj1, obj2, showAllDiff, added, deleted, differencesCounter) {
        const key1 = Object.keys(obj1);
        const key2 = Object.keys(obj2);
        const mergeKey = [...new Set(key2.concat(key1))];
        const merged = Object.create(null);
        mergeKey.forEach(key => {
            if (obj1.hasOwnProperty(key) && obj2.hasOwnProperty(key)) {
                if (this.getType(obj2[key]) === this.getType(obj1[key])) {
                    if (this.isObject(obj2[key])) {
                        merged[key] = this.mergeObj(obj1[key], obj2[key], showAllDiff, added, deleted, differencesCounter);
                    } else if (this.isArray(obj2[key])) {
                        merged[key] = this.mergeArr(obj1[key], obj2[key], showAllDiff, added, deleted, differencesCounter);
                    } else {
                        if (obj2[key] !== obj1[key]) {
                            differencesCounter.updated += 1;
                        }
                        merged[key] = obj2[key];
                    }
                } else {
                    differencesCounter.updated += 1;
                    merged[key] = obj2[key];
                }
            } else {
                let checkDelete = true;
                checkDelete = this.registerAllItems(merged, (showAllDiff || added), null, obj2, key, true, showAllDiff, added, deleted, differencesCounter, "added");
                if (checkDelete) {
                    checkDelete = this.registerAllItems(merged, (showAllDiff || deleted), obj1, null, key, true, showAllDiff, added, deleted, differencesCounter, "deleted");
                }
            }
        });
        return merged;
    },

    registerAllItems(merged, permission, item1, item2, kIndex, typeObject, showAllDiff, added, deleted, differencesCounter, action) {
        let check = true;
        if (permission) {
            const primaryItem = item1 || item2; let
                mergedData;
            if (primaryItem.hasOwnProperty(kIndex) && this.isArray(primaryItem[kIndex])) {
                const data = this.mergeArr((item1 ? item1[kIndex] : []), (item2 ? item2[kIndex] : []), showAllDiff, added, deleted, differencesCounter);
                differencesCounter[action] += 2;
                mergedData = { data };
            } else if (primaryItem.hasOwnProperty(kIndex) && this.isObject(primaryItem[kIndex])) {
                const data = this.mergeObj((item1 ? item1[kIndex] : {}), (item2 ? item2[kIndex] : {}), showAllDiff, added, deleted, differencesCounter);
                differencesCounter[action] += 2;
                mergedData = { data };
            } else if (primaryItem.hasOwnProperty(kIndex)) {
                if (typeObject || (!merged.includes(primaryItem[kIndex]))) {
                    const data = primaryItem[kIndex];
                    differencesCounter[action] += 1;
                    mergedData = { data };
                }
            }

            if (mergedData) {
                check = false;
                if (typeObject) {
                    merged[kIndex] = mergedData.data;
                } else {
                    merged.push(mergedData.data);
                }
            }
        }
        return check;
    }
};
